import { Select, MenuItem } from "@mui/material";
import { useRTL } from "hooks/isRTL";

const DropdownMenu = ({ placeholder, options, value, onChange }) => {
  const { isRTL } = useRTL();

  return (
    <Select
      value={value ?? ""}
      displayEmpty
      renderValue={(selected) => {
        // Treat only empty string / null / undefined as empty. Numeric `0` is a valid selection.
        if (selected === "" || selected === null || selected === undefined) {
          return (
            <span
              style={{
                color: "#5C5757",
              }}
            >
              {placeholder}
            </span>
          );
        }

        const selectedOption = options.find(
          (option) => option.value === selected
        );
        return selectedOption ? selectedOption.label : selected;
      }}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        minWidth: "180px",
        height: "40px",
        borderRadius: "8px",
        backgroundColor: "#ffffff",
        "& .MuiOutlinedInput-root": {
          height: "40px",
          display: "flex",
          flexDirection: isRTL ? "row-reverse" : "row",
          borderRadius: "8px",
          border: "2px solid #E0E0E0",
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "#B0B0B0",
            backgroundColor: "#f9f9f9",
          },
          "&.Mui-focused": {
            borderColor: "#2A3467",
            backgroundColor: "#ffffff",
            boxShadow: "0 0 0 3px rgba(42, 52, 103, 0.1)",
          },
          "& fieldset": {
            border: "none",
          },
        },
        "& .MuiSelect-icon": {
          left: isRTL ? "12px" : "unset",
          right: isRTL ? "unset" : "12px",
          color: "#2A3467",
          transition: "transform 0.3s ease",
        },
        "& .MuiSelect-icon.MuiSelect-iconOpen": {
          transform: "rotate(180deg)",
        },
      }}
      inputProps={{
        sx: {
          paddingRight: isRTL ? "12px !important" : "40px !important",
          paddingLeft: isRTL ? "40px !important" : "12px !important",
          textAlign: isRTL ? "right" : "left",
          fontWeight: "500",
          color: "#2A3467",
          fontSize: "14px",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            marginTop: "4px",
            "& .MuiMenuItem-root": {
              padding: "10px 16px",
              fontWeight: "500",
              color: "#2A3467",
              fontSize: "14px",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "rgba(42, 52, 103, 0.08)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(42, 52, 103, 0.15)",
                color: "#2A3467",
                fontWeight: "600",
                "&:hover": {
                  backgroundColor: "rgba(42, 52, 103, 0.2)",
                },
              },
            },
          },
        },
      }}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropdownMenu;
